const handleAccordionsDifferent = () => {
    const $accordion = $('.js-accordion-different');
    const $accordionTrigger = $accordion.find('.accordion__head');
    $accordion.find('.accordion__section').not('.is-active').find('.accordion__body').slideUp();

    //Handle the show/hide logic
    $accordionTrigger.on('click', function (event) {
    	$(this).next().stop().slideToggle()
    		.parent().toggleClass('is-active')
    		.siblings().removeClass('is-active')
    			.find('.accordion__body').slideUp();
    });
};

handleAccordionsDifferent();